import { useCallback, useState } from 'react'

/** A boolean UI flag that survives refresh/remount via localStorage (per browser, no backend). */
export function useStoredFlag(
  key: string,
  fallback: boolean,
): [boolean, (next: boolean) => void] {
  const [value, setValue] = useState(() => {
    try {
      const stored = localStorage.getItem(key)
      return stored === null ? fallback : stored === '1'
    } catch {
      return fallback
    }
  })

  const set = useCallback(
    (next: boolean) => {
      setValue(next)
      try {
        localStorage.setItem(key, next ? '1' : '0')
      } catch {
        /* localStorage unavailable — flag just won't persist */
      }
    },
    [key],
  )

  return [value, set]
}
